export const isValidObjectId = (data: any): boolean => {
  return new RegExp('^[a-f\\d]{24}$', 'i').test(data);
};

/**
 * Generates a MongoDB-compatible ObjectId
 * @returns A 24-character hexadecimal string
 */
export const ObjectId = (): string => {
  const timestamp = Math.floor(Date.now() / 1000)
    .toString(16)
    .padStart(8, '0');
  const randomValue = Array.from({ length: 16 }, () =>
    Math.floor(Math.random() * 16).toString(16)
  ).join('');

  return timestamp + randomValue;
};
